import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import cookie from "react-cookies";

import {
  getOrderDetailsRashan,
  getOrderDetailsRashanStore,
} from "../../../Request/OrderRequests";
import "../index.css";
import paymentIcon from "../../../img/icon-payment.png";
import paytmIcon from "../../../img/icon-paytm.png";
export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const MyOrder = () => {
  const navigate = useNavigate();
  // const [currentState, setState] = useState("cartLoginSpan");
  const user = useSelector((s) => s.user.info);
  // const [menu, setMenu] = useState("Active");
  const [orders, setOrders] = useState([]);
  const [storeOrders, setStoreOrders] = useState([]);
  const [loadMore, setLoadMore] = useState(2);

  // const [pastOrders, SetpastOrders] = useState(0);
  useEffect(() => {
    if (user?.userHash) {
      getOrderDetailsRashan(cookie.load("uid"))
        .then((res) => setOrders(res.reverse()))
        .catch((err) => console.log(err));
    }
    if (user?.phn) {
      getOrderDetailsRashanStore(user?.phn)
        .then((res) => setStoreOrders(res))
        .catch((err) => console.log(err));
    }
  }, [user]);
  const allOrders = useMemo(() => {
    const combinedOrders = [...orders, ...storeOrders];
    for (let i = 0; i < combinedOrders.length; i++) {
      for (let i = 0; i < combinedOrders.length; i++) {
        if (
          new Date(combinedOrders[i]?.orderplaced).getTime() <
          new Date(combinedOrders[i + 1]?.orderplaced).getTime()
        ) {
          let temp = combinedOrders[i];
          combinedOrders[i] = combinedOrders[i + 1];
          combinedOrders[i + 1] = temp;
        }
      }
    }
    return combinedOrders;
  }, [orders, storeOrders, loadMore]);

  // MAIN JSX RETURN
  return (
    orders && (
      <>
        {orders.length > 0 ? (
          <div className="accountOrders-list">
            <h2>My Orders</h2>
            <div className="My1">
              {allOrders?.map((order, index) => {
                if (index > loadMore) {
                  return;
                }
                return (
                  <div
                    key={order?.order_id}
                    onClick={() =>
                      navigate(`/placedorderdetails/${order?.order_id}`)
                    }
                  >
                    <MyOrderCard key={order?.order_id} order={order} />
                  </div>
                );
              })}

              {loadMore < orders.length ? (
                <h2
                  className="My2"
                  onClick={() =>
                    setLoadMore((prevState) => {
                      if (prevState >= orders.length) {
                        return prevState;
                      }
                      return prevState + 3;
                    })
                  }
                >
                  Load more orders
                </h2>
              ) : null}
            </div>
          </div>
        ) : null}
      </>
    )
  );
};

export const MyOrderCard = ({ order, storeOrder }) => {
  const {
    billamount,
    order_count,
    order_id,
    orderplaced,
    shopname,
    status,
    statusDate,
    vendor_order_no,
    vendoraddress,
    paymentMethod,
    mode,
  } = order;
  // console.log(order);
  const date = orderplaced ? new Date(orderplaced) : new Date(order?.orderDate);
  return (
    <div className="card">
      <div className="card-body My3">
        <div className="d-flex My4">
          <h4 className="My5">Total Items: {order_count}</h4>
          <span className="ms-auto My6">
            {date.getDate()} {MONTHS[date.getMonth()]} {date.getFullYear()},{" "}
            {date.getHours() % 12 || 12}:
            {`${date.getMinutes()}`.padStart(2, "0")}{" "}
            {date.getHours() <= 12 ? "AM" : "PM"}
          </span>
        </div>
        <div className="d-flex align-items-center">
          <h4 className="My7">
            {`${mode === "Store" ? "STORE" : "ONLINE"}`} ORDER
          </h4>
          {/* SAVINGS TAG------------------- */}
          {/* <h5 className="ms-auto My9">₹100 savings</h5> */}
        </div>
        {paymentMethod === "PayTM" ? (
          <div className="d-flex align-items-center">
            <div className="My8">
              <img
                src={paytmIcon}
                alt="Google Pay"
                width={20}
                style={{ marginBottom: "4px" }}
              />
            </div>
            <span className="My7">PayTM</span>
          </div>
        ) : (
          <div className="d-flex align-items-center">
            <div className="My8">
              <img
                src={paymentIcon}
                alt="Google Pay"
                width={20}
                style={{ marginBottom: "4px" }}
              />
            </div>
            <span className="My7">{paymentMethod}</span>
          </div>
        )}
      </div>
      {(status === "Pending" || status === "Accepted") && (
        <div className="card-footer text-center bg-light-green border-0 text-green My10">
          {/* TRACK ORDER */}
          {status}
        </div>
      )}

      {(status === "Cancelled" || status === "Delivered") && (
        <div className="card-footer text-center bg-light-orange border-0 text-orange My10">
          {/* DELIVERED */}
          {status}
        </div>
      )}
    </div>
  );
};
export default MyOrder;
